import ar from '@/local/ar';

export const partyTypeEnum = {
  person: 1, // فرد
  firm: 2, // شركة
  organization: 3, // مؤسسة
  government: 4, // جهة حكومية
  foreignCompany: 9, // شركة أو مؤسسة أجنبية
};

export const partyTypeNames = {
  1: 'person', // فرد
  2: 'firm', // شركة
  3: 'organization', // مؤسسة
  9: 'foreignCompany',
};

export const identityTypeEnum = {
  nationalId: 1,
  regularResidency: 2,
};

export const identityTypes = {
  1: 'nationalId',
  2: 'regularResidency',
};

export const legalCapacitiesEnum = {
  lawyer: 1,
  administrativeEntityRepresentative: 2,
  legalEntityRepresentative: 3,
  bankruptcySecretary: 4,
  partner: 5,
  employee: 6,
  creditor: 7,
  debtor: 8,
  bankrupt: 9,
  competentParty: 10,
  agent: 11,
  interestParty: 15,
};

export const requestReplyTypes = { inComplete: 8 };

export const requestOwnerTypeEnum = {
  debtor: 1,
  creditor: 2,
  competentParty: 3,
  stakeholder: 4,
  bankruptcyCommission: 5,
  trustee: 6,
};

export const mainRequestCategoryEnum = {
  open: 1,
  deposit: 2,
};

export const procedureTypeEnum = {
  preventiveSettlement: 1,
  financialReorganization: 2,
  liquidation: 3,
  smallDebtorPreventiveSettlement: 4,
  smallDebtorsFinancialReorganization: 5,
  smallDebtorsLiquidation: 6,
  administrativeLiquidation: 7,
};

export const stepsEnum = {
  basicData: 1,
  requestApplicantData: 2,
  requestDetails: 3,
  requestAttachments: 4,
};

export const attorneyTypeEnum = {
  internal: 1,
  external: 2,
};

export const activitiesStatusEnum = {
  active: true,
  inActive: false,
};
export const partyTypesBankRuptcyFile = {
  person: 1,
  firm: 2,
  organization: 3,
};

export const requestStatusEnum = {
  draft: 1,
  new: 2,
  underAudit: 3,
  inComplete: 4,
  returnedToAudit: 5,
  transferredToCircuit: 6,
  underStudy: 7,
  underConsideration: 8,
  opened: 9,
  rejected: 10,
  dismissed: 11,
  closed: 12,
  rejectedAndReplaced: 13,
  closedAndReplaced: 14,
  transferringToCircuitInProgress: 15,
};

export const booleanEnum = {
  yes: true,
  no: false,
};

export const paymentStatusEnum = {
  notPaid: 1,
  partiallyPaid: 2,
};

export const creditorClassificationsEnum = {
  funding: 1,
  governmental: 2,
  other: 3,
};

export const debtorAssetTypeEnum = {
  bankAccount: 1, //            حساب بنكي
  investmentPortfolio: 2, //    محفظة استثمارية
  realEstate: 3, //             عقار
  vehicle: 4, //                مركبة
  transported: 5, //            منقول
  other: 99, //                  اخرى
};

export const organizedEntityTypesEnum = { other: 22 };

export const requestReplyEnum = {
  submitNewRequest: 2,
  completeRequest: 3,
};

export const mainRequestDetailsTypesEnum = {
  partners: 1,
  branches: 2,
  bankruptDebts: 3,
  debtorAssets: 4,
  bankruptDueRights: 5,
  debtorEmployees: 6,
  interestedParties: 7,
};

export const mainRequestAuditFlag = {
  basicDetailsConfirmation: 1,
  specializedCourtConfirmation: 2,
  applicantDetailsConfirmation: 3,
  bankruptDetailsConfirmation: 4,
  bankruptActivitiesConfirmation: 5,
  proofBankruptcyConfirmation: 6,
  debtorFinancialPositionConfirmation: 7,
  secretaryDetailsConfirmation: 8,
  bankruptDebtsConfirmation: 9,
  bankruptDueRightsConfirmation: 10,
  branchesConfirmation: 11,
  debtorAssetsConfirmation: 12,
  debtorEmployeesConfirmation: 13,
  partnersConfirmation: 14,
  creditorDetailsConfirmation: 15,
  relatedRequestsConfirmation: 16,
  attorneyConfirmation: 17,
  interestedPartiesConfirmation: 18,
};

export const mainRequestStep = {
  admissionAndAudit: 1,
  circuitOperation: 2,
  openedProcedure: 3,
  done: 4,
  rejected: 5,
};

export const fileType = {
  pdf: 1,
  img: 2,
};

export const formFieldTypes = {
  text: 1,
  number: 2,
  date: 3,
  selectbox: 4,
  checkbox: 5,
  textarea: 6,
  radioButton: 7,
  multipleSelectBox: 8,
  fieldsSection: 11,
  button: 21,
  dataGrid: 22,
  map: 23,
  formula: 24,
};
const subRequestsLocal = ar.bankruptcy.subRequests;

export const subRequestActionType = {
  submitSubRequest: 1,
  updateSubRequest: 4,
};

export const subRequestType = {
  GeneralRequest: 100009,
  VerdictObjectionRequest: 1,
  AddRepresentative: 2,
  SuspensionOfClaims: 3,
  ApproveClaimsListRequest: 5,
  RecoveringAssetDisposedDuringClaimsSuspensionRequest: 7,
  ExecuteBankruptcyAssetsProvidedAsSecurityRequest: 9,
  ExecuteAssetsGuarantorOfTheDebtorsDebtRequest: 10,
  ProposedAmendmentRequest: 18,
  ProposalRatificationRequest: 19,
  EditPlanRequest: 20,
  ObjectionToProcedureOrDecisionRequest: 26,
  ExtendingSuspendingClaimsPeriodRequest: 27,
  SecretaryRemovalOrRetirementRequest: 33,
  EstimatingSecretaryOrExpertFeesRequest: 35,
  EstimatingDebtorAdequacyAndHisDependentsRequest: 37,
  ExtendSubmittingClaimsListDeadlineRequest: 42,
  EndProcedureRequest: 50,
  DetermineBankruptcyAssetsMustBeDeclaredRequest: 52,
  TerminateEmployeeContractsRequest: 55,
  CourtApprovedMultipleDistributionsOfBankruptcyEstateProceeds: 57,
  ExtendSubmittingProposalDeadlineRequest: 65,
  SubmittingPollResultRequest: 70,
  QuarterProgressReportForPlanImplementationRequest: 72,
  QuarterRoutineReportForLiquidationProcedureRequest: 73,
  SubmittingInventoryOfBankruptcyAssetsRequest: 74,
  SuggestionDepositRequest: 75,
  RequestForCourtApprovalOfDebtorClaim: 76,
  RequestToLiftTravelBan: 77,
  LiftingLienOnAssetsOfDebtorOrGuarantorOfDebtorDebt: 78,
  RequestToTerminateContractsFromDebtor: 79,
  RequestToCompelDeliveryOfDocumentsToDebtorOrThirdParty: 80,
  RecoveryOfAssetInPossessionOfDebtorOrSeizedHolderRequest: 83,
  SuspensionOfClaimsForASpecificDemandRequest: 84,
  RequestToSetAnotherVotingDateRequest: 85,
  ApprovalToObtainSecuredFinancingRequest: 86,
  ObjectionToDebtorsActionWithAnotherPartyBeforeProcedureRequest: 87,
  SanctionBasedOnArticle203ForActionsInArticles200202Request: 88,
  RecoveryOfAssetRequest: 89,
  RequestToTerminateContractByContractorRequest: 90,
  ObjectionToThePlanRequest: 91,
  RequestToApproveAndSubmitProposalAmendmentRequest: 92,
  RequestForPrecautionaryMeasureRequest: 93,
  RequestToConsiderDebtorsClaimAgainstOthersRequest: 94,
  ExtensionOfClaimsSuspensionDeadlineRequest: 95,
  ApprovalOfClaimsAfterStatutoryDeadlineRequest: 96,
  ExtensionOfContractTerminationDeadlineRequest: 97,
  SubjectingAnotherPersonToFinancialProcedureRequest: 98,
  EnableCreditorToVoteOnProposalRequest: 99,
  RequestToRecoverAssetDisposedDuringSuspensionPeriodRequest: 100,
  RequestToReviewObstaclePreventingPlanExecutionRequest: 101,
  IssuanceOfDecisionToFormCreditorsCommitteeRequest: 102,
  ApprovalOfProposedCreditorsCommitteeRequest: 103,
  DebtorsDisqualificationFromManagementRequest: 104,
  ApprovalToSellDisputedBankruptcyAssetRequest: 105,
  CreditorsObjectionToDistributionDecisionRequest: 106,
  ApprovalToAmendDistributionDecisionRequest: 107,
  PostponeLiquidationTerminationRequest: 108,
  RequestForPrecautionaryActionAfterInitiationRequestRequest: 109,
  CourtApprovalToStopVerifyingClaimsRequest: 110,
  DocumentSubmissionRequest: 111,
  ContractTerminationRequestByContractorRequest: 112,
  RequestToSubmitTheProposalForFinancialRestructuringProcedure: 113,
  CompensationForDamageFromAssetRecovery: 116,
  RequestToIncludeCreditorClaimInProposal: 117,
  CourtApprovalForGuaranteeDuringLiquidation: 118,
  ApprovalForDisputedCreditorToVoteOnArticle108Cases: 119,
  RequestToTerminatePrecautionaryMeasure: 120,
  SubjectingAssetCoOwnedByDebtorWithAnotherPersonToProcedure: 121,
  RequestToReplaceGuaranteeForOneCreditorWithAnother: 122,
  RequestToIncludeClauseInProposalToWaiveGuaranteeForCreditor: 123,
  AppointmentOfReplacementForCreditorsCommitteeMember: 124,
  TerminationOfContractByContractingParty: 125,
  ApprovalToObtainUnsecuredFinancing: 126,
  RequestToObligeJointOwnersToPayDeficit: 127,
  DistributionOfFundsWithinTwentyFourMonths: 128,
  SuspensionOfClaimsDueToInfluentialSituation: 129,
  RecoveryOfCreditorsSpecificSecurityFromDebtor: 130,
  SettingAnotherDateForVotingDueToInability: 131,
  ApprovalForDebtorToPerformProhibitedAction: 132,
  SubjectingDebtorToLiquidation: 133,
  TerminationOfContractorContractWithDebtorAtContractorRequest: 134,
  RequestToSubmitDocumentsHeldByDebtorOrThirdParty: 135,
};

export const subRequestTypeIds = {
  100009: 'GeneralRequest',
  1: 'verdictObjectionRequest',
  2: 'addRepresentative',
  3: 'suspensionOfClaims',
  5: 'approveClaimsListRequest',
  7: 'recoveringAssetDisposedDuringClaimsSuspensionRequest',
  9: 'executeBankruptcyAssetsProvidedAsSecurityRequest',
  10: 'executeAssetsGuarantorOfTheDebtorsDebtRequest',
  18: 'proposedAmendmentRequest',
  19: 'proposalRatificationRequest',
  20: 'editPlanRequest',
  26: 'objectionToProcedureOrDecisionRequest',
  27: 'extendingSuspendingClaimsPeriodRequest',
  33: 'secretaryRemovalOrRetirementRequest',
  35: 'estimatingSecretaryOrExpertFeesRequest',
  37: 'estimatingDebtorAdequacyAndHisDependentsRequest',
  42: 'extendSubmittingClaimsListDeadlineRequest',
  50: 'endProcedureRequest',
  52: 'determineBankruptcyAssetsMustBeDeclaredRequest',
  55: 'terminateEmployeeContractsRequest',
  57: 'courtApprovedMultipleDistributionsOfBankruptcyEstateProceeds',
  65: 'extendSubmittingProposalDeadlineRequest',
  70: 'submittingPollResultRequest',
  72: 'quarterProgressReportForPlanImplementationRequest',
  73: 'quarterRoutineReportForLiquidationProcedureRequest',
  74: 'submittingInventoryOfBankruptcyAssetsRequest',
  75: 'suggestionDepositRequest',
  76: 'requestForCourtApprovalOfDebtorClaim',
  77: 'requestToLiftTravelBan',
  78: 'liftingLienOnAssetsOfDebtorOrGuarantorOfDebtorDebt',
  79: 'requestToTerminateContractsFromDebtor',
  80: 'requestToCompelDeliveryOfDocumentsToDebtorOrThirdParty',
  83: 'RecoveryOfAssetInPossessionOfDebtorOrSeizedHolderRequest',
  84: 'SuspensionOfClaimsForASpecificDemandRequest',
  85: 'RequestToSetAnotherVotingDateRequest',
  86: 'ApprovalToObtainSecuredFinancingRequest',
  87: 'ObjectionToDebtorsActionWithAnotherPartyBeforeProcedureRequest',
  88: 'SanctionBasedOnArticle203ForActionsInArticles200202Request',
  89: 'RecoveryOfAssetRequest',
  90: 'RequestToTerminateContractByContractorRequest',
  91: 'ObjectionToThePlanRequest',
  92: 'RequestToApproveAndSubmitProposalAmendmentRequest',
  93: 'RequestForPrecautionaryMeasureRequest',
  94: 'RequestToConsiderDebtorsClaimAgainstOthersRequest',
  95: 'ExtensionOfClaimsSuspensionDeadlineRequest',
  96: 'ApprovalOfClaimsAfterStatutoryDeadlineRequest',
  97: 'ExtensionOfContractTerminationDeadlineRequest',
  98: 'SubjectingAnotherPersonToFinancialProcedureRequest',
  99:  'EnableCreditorToVoteOnProposalRequest',
  100: 'RequestToRecoverAssetDisposedDuringSuspensionPeriodRequest',
  101: 'RequestToReviewObstaclePreventingPlanExecutionRequest',
  102: 'IssuanceOfDecisionToFormCreditorsCommitteeRequest',
  103: 'ApprovalOfProposedCreditorsCommitteeRequest',
  104: 'DebtorsDisqualificationFromManagementRequest',
  105: 'ApprovalToSellDisputedBankruptcyAssetRequest',
  106: 'CreditorsObjectionToDistributionDecisionRequest',
  107: 'ApprovalToAmendDistributionDecisionRequest',
  108: 'PostponeLiquidationTerminationRequest',
  109: 'RequestForPrecautionaryActionAfterInitiationRequestRequest',
  110: 'CourtApprovalToStopVerifyingClaimsRequest',
  111: 'DocumentSubmissionRequest',
  112: 'ContractTerminationRequestByContractorRequest',
  113: 'RequestToSubmitTheProposalForFinancialRestructuringProcedure',
  116: 'CompensationForDamageFromAssetRecovery',
  117: 'RequestToIncludeCreditorClaimInProposal',
  118: 'CourtApprovalForGuaranteeDuringLiquidation',
  119: 'ApprovalForDisputedCreditorToVoteOnArticle108Cases',
  120: 'RequestToTerminatePrecautionaryMeasure',
  121: 'SubjectingAssetCoOwnedByDebtorWithAnotherPersonToProcedure',
  122: 'RequestToReplaceGuaranteeForOneCreditorWithAnother',
  123: 'RequestToIncludeClauseInProposalToWaiveGuaranteeForCreditor',
  124: 'AppointmentOfReplacementForCreditorsCommitteeMember',
  125: 'TerminationOfContractByContractingParty',
  126: 'ApprovalToObtainUnsecuredFinancing',
  127: 'RequestToObligeJointOwnersToPayDeficit',
  128: 'DistributionOfFundsWithinTwentyFourMonths',
  129: 'SuspensionOfClaimsDueToInfluentialSituation',
  130: 'RecoveryOfCreditorsSpecificSecurityFromDebtor',
  131: 'SettingAnotherDateForVotingDueToInability',
  132: 'ApprovalForDebtorToPerformProhibitedAction',
  133: 'SubjectingDebtorToLiquidation',
  134: 'TerminationOfContractorContractWithDebtorAtContractorRequest',
  135: 'RequestToSubmitDocumentsHeldByDebtorOrThirdParty',
};

export const subRequestTypesEnum = {
  'objectionRequest': {
    isEnabled: true,
    id: subRequestType.VerdictObjectionRequest,
    name: subRequestTypeIds[subRequestType.VerdictObjectionRequest],
    header: subRequestsLocal.objectionRequest.header,
    title: subRequestsLocal.objectionRequest.title,
    customComponentName: 'BankruptcyObjectionRequest',
    requestReasonsType: 'list',
    showAttachmentSection: false,
    showRequestReasonSection: true,
    showRequestReasonAttachment: true,
    fullExplanation: subRequestsLocal.objectionRequest.fullExplanation,
    shortExplanation: ar.bankruptcy.subRequests.objectionRequest.shortExplanation,
    canAddNewStackHolder: true,
    showAttorneyForm: true,
    showJudgementCodeQuery: true,
    showDefaultRequestApplicantSection: true,
  },
  'addRepresentative': {
    isEnabled: true,
    id: subRequestType.AddRepresentative,
    name: subRequestTypeIds[subRequestType.AddRepresentative],
    header: subRequestsLocal.addRepresentative.header,
    title: subRequestsLocal.addRepresentative.title,
    customComponentName: 'BankruptcyAddRepresentative',
    requestReasonsType: 'list',
    showAttachmentSection: false,
    showRequestReasonSection: false,
    showRequestReasonAttachment: false,
    fullExplanation: subRequestsLocal.addRepresentative.fullExplanation,
    shortExplanation: subRequestsLocal.addRepresentative.shortExplanation,
    canAddNewStackHolder: false,
    showAttorneyForm: false,
    showJudgementCodeQuery: false,
    showDefaultRequestApplicantSection: false,
  },
  'GeneralRequest': {
    id: subRequestType.GeneralRequest,
    name: subRequestsLocal.GeneralRequest.title,
    componentName: 'BankruptcyGeneralRequest',
    fullExplanation: '',
  },
};

export const stakeholderTypesEnum = {
  partner: 1,
  employee: 2,
  creditor: 3,
  interestParty: 4,
};
export const stakeholderTypeNames = {
  1: 'partner',
  2: 'debtorEmployee',
  3: 'creditor',
  4: 'interestParty',
};

export const subRequestStatus = {
  waitingObjectionDueDate: 1,
  new: 2,
  transferredToCircuit: 3,
  rejected: 4,
  dismissed: 5,
  underAudit: 6,
  underConsideration: 7,
  inComplete: 8,
  accepted: 9,
  referredToAppealCourt: 10,
  onProgressConsideration: 17,
};

export const subRequestCircleActions = {
  decision: 1,
  deposit: 2,
  session: 3,
};

export const managerIdentityTypeEnum = {
  nationalId: 1,
  regularResidency: 2,
  tempResidency: 3,
  passport: 4,
  gulfCountry: 7,
  travelAndWorkCard: 9,
  visitor: 13,
  identityOfMotamer: 16,
};

export const managerIdentityTypes = {
  1: 'nationalId',
  2: 'regularResidency',
  3: 'tempResidency',
  4: 'passport',
  7: 'gulfCountry',
  9: 'travelAndWorkCard',
  13: 'visitor',
  16: 'identityOfMotamer',
};

export const procedureStatusEnum = {
    opened: 1,
    Closed: 2,
    ClosedAndReplacedByNewOpenedProcedure: 3,
};